module.exports = __webpack_public_path__ + "img/5.3a80b27f.jpg";